
import { projects } from "../data/Projects";
import React, {ReactElement, FC} from "react";
import "./styles/Project.css"

const Projects: FC<any> = (): ReactElement => {
  return (
    <section id="projects" className="project-section-container">
      <div className="project-container">
        <div className="project-title-container">
          <h1 className="project-title-wrapper">
            Projects that I worked on
          </h1>
          <p className="project-text-wrapper">
            The following are the projects that I have worked on or was a part of during my internship or school period. Some projects includes side projects that were done with friends, others are projects that were part of the school curriculum.
          </p>
        </div>
        <div className="project-content-container">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="project-link">
              <div className="project-content-wrapper">
              <h1 className="project-content-title">
                    {project.title}
                  </h1>
                <img
                    alt="gallery"
                    className="project-content-image"
                    src={project.image}
                    width={project.width? project.width :  "40" }
                    height={project.height? project.height :  "40" }
                />
                <div className="project-content-subtitle-container">
                  <h2 className="project-content-subtitle-h2">
                    {project.subtitle}
                  </h2>
                 
                  <p className="project-content-description">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;